import { COMMON_CONTENT } from './common';

export const TERMS_CONTENT = {
  title: 'Terms of Service',
  breadcrumb: 'Terms of Service',
  lastUpdated: 'January 1, 2026',
  introduction: `Welcome to ${COMMON_CONTENT.brand.name}! These Terms govern your use of our site.`,
  email: COMMON_CONTENT.brand.email,
  sections: [
    {
      title: 'Acceptance of Terms',
      content:
        'By accessing and using this website, you accept and agree to be bound by the terms and provision of this agreement.',
    },
    {
      title: 'Use License',
      content:
        'Permission is granted to temporarily use this website for personal, non-commercial use only.',
    },
    {
      title: 'Privacy Policy',
      content:
        'Your privacy is important to us. Please read our Privacy Policy to understand how we collect and use your information.',
    },
  ],
} as const;

export const PRIVACY_CONTENT = {
  breadcrumb: 'Privacy Policy',
  title: 'Privacy Policy',
  lastUpdated: 'January 1, 2026',
  introduction: `At ${COMMON_CONTENT.brand.name}, we protect your data like our own.`,
  sections: [
    {
      title: 'Information We Collect',
      content: [
        'Personal information (name, email, address, phone) when you create an account or place an order',
        'Payment information processed securely through our payment providers',
        'Browsing and purchase history to improve your shopping experience',
        'Device and browser information for website optimization',
      ],
    },
    {
      title: 'How We Use Your Information',
      content: [
        'Process and fulfill your orders efficiently',
        'Send order confirmations and critical shipping updates',
        'Provide dedicated and personalized customer support',
        'Send promotional emails (you can opt-out at any time)',
        'Continuously improve our website and unique product offerings',
        'Prevent fraudulent activities and ensure platform security',
      ],
    },
    {
      title: 'Information Sharing',
      content: [
        'We never sell your personal information to any third parties',
        'We share necessary information with shipping carriers for delivery',
        'Payment processors handle your sensitive data with PCI compliance',
        'We may share information if strictly required by legal authorities',
      ],
    },
    {
      title: 'Data Security',
      content: [
        'We use industry-standard SSL/TLS encryption for all data',
        'Payment information is never stored on our local servers',
        'Regular internal security audits and infrastructure updates',
        'Employee access to user data is strictly limited and monitored',
      ],
    },
    {
      title: 'Your Rights',
      content: [
        'Right to access and view all your personal data',
        'Right to update or correct any inaccurate information',
        'Right to request full deletion of your account and data',
        'Right to opt-out of all marketing communications',
        'Right to export your data in a portable format',
      ],
    },
    {
      title: 'Cookies',
      content: [
        'Preference cookies to remember your cart and settings',
        'Analytics cookies to understand how you interact with us',
        'Marketing cookies to show relevant stories and deals',
        'You have full control over cookie settings in your browser',
      ],
    },
  ],
} as const;

export const SHIPPING_RETURNS_CONTENT = {
  breadcrumb: 'Shipping & Returns',
  title: 'Fast delivery, easy returns',
  subtitle:
    "Everything you need to know about how we get your new friends to you, and what to do if they're not quite right.",
  shipping: {
    title: 'Shipping Options',
    methods: [
      {
        id: 'standard',
        icon: 'Truck',
        title: 'Standard Shipping',
        time: '3-5 business days',
        price: '₹ 299.00',
        color: 'bg-primary-50 text-primary-600',
      },
      {
        id: 'express',
        icon: 'Clock',
        title: 'Express Shipping',
        time: '1-2 business days',
        price: '₹ 499.00',
        color: 'bg-primary-50 text-primary-600',
      },
      {
        id: 'secure',
        icon: 'Shield',
        title: 'Secure Packaging',
        time: 'Protected delivery',
        price: 'Included',
        color: 'bg-primary-50 text-primary-600',
      },
    ],
  },
  returns: {
    title: '30-Day Policy',
    description:
      'Not completely in love? No problem. Return any unused item within 30 days for a full refund.',
    highlights: [
      'Full refund to original payment method',
      'Free return shipping on manufacturing defects',
      'Easy online return portal access',
      '365-day warranty on all stitching',
    ],
    nonReturnable: {
      title: 'Non-Returnable Items',
      items: [
        'Personalized or custom embroidered toys',
        'Items that have been washed or clearly used',
        'Toys missing their original security tags',
        'Final sale and promotional gift items',
      ],
    },
    process: {
      title: 'The Return Process',
      steps: [
        { step: 1, title: 'Request Return', desc: 'Contact us within 30 days' },
        { step: 2, title: 'Ship Item Back', desc: 'Use provided label' },
        { step: 3, title: 'Inspection', desc: 'We check the item' },
        { step: 4, title: 'Refund', desc: 'Money back in 3-5 days' },
      ],
    },
  },
} as const;
